import React, { useState } from "react";
import { Button, Input, message, Modal, notification } from "antd";
import {
  BankEmployee,
  BankEmployeeList,
} from "./BankEmployeeList/BankEmployeeList";
import { SELECT_BANK_EMPLOYEES } from "../../../store/selectors/authSliceLoginSelector";
import { useSelector } from "react-redux";
import { useSetApplicationBankEmployeeMutation } from "../../../store/api/applicationBankApi/applicationBank.api";
import { useParams } from "react-router-dom";

import classes from "./BankEmployeeChange.module.css";

import { getFullName } from "../../../utils/utilities/getFullName";
interface BankEmployeeChangeModalProps {
  isOpen: boolean;
  hideModal: () => void;
}

export function BankEmployeeChangeModal(props: BankEmployeeChangeModalProps) {
  const { isOpen, hideModal } = props;
  const { applicationBankId } = useParams();
  const bankEmployees: readonly BankEmployee[] = useSelector(
    SELECT_BANK_EMPLOYEES
  );

  const [setApplicationBankEmployee, { isLoading }] =
    useSetApplicationBankEmployeeMutation();

  const [filteredBankEmployees, setFilteredBankEmployees] =
    useState(bankEmployees);

  const [selectedBankEmployee, setSelectedBankEmployee] =
    useState<BankEmployee | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value;
    const filteredItems = bankEmployees.filter((user) =>
      `${user.surname} ${user.name} ${user.patronymic}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
    setFilteredBankEmployees(filteredItems);
  };

  const handleOk = async () => {
    if (selectedBankEmployee && applicationBankId) {
      try {
        await setApplicationBankEmployee({
          applicationBankId: +applicationBankId,
          bankEmployeeId: selectedBankEmployee.id,
        }).unwrap();
        // navigate("/", { replace: true });
        notification.success({
          message: "Сотрудник сопровождения изменен",
          description: `Заявка № ${applicationBankId} была успешно передана новому сотруднику сопровождения: ${getFullName(
            selectedBankEmployee
          )}`,
          duration: 0,
        });
      } catch (serverError) {
        message.error("Не получилось назначить сотрудника сопровождения");
      } finally {
        hideModal();
      }
    }
  };

  const handleCancel = () => {
    hideModal();
  };

  return (
    <>
      <Modal
        className={classes.modal}
        open={isOpen}
        title="Список сотрудников сопровождения"
        footer={false}
        closeIcon={false}
      >
        <Input.Search
          placeholder="Поиск по имени"
          style={{ marginBottom: "10px" }}
          onChange={handleInputChange}
        />
        <BankEmployeeList
          bankEmployees={filteredBankEmployees}
          selectedBankEmployee={selectedBankEmployee}
          setSelectedBankEmployee={setSelectedBankEmployee}
        />
        <div className={classes.div}>
          <Button onClick={handleCancel}>Отменить</Button>

          <Button type="primary" onClick={handleOk} loading={isLoading}>
            Подтвердить выбор
          </Button>
        </div>
      </Modal>
    </>
  );
}
